
<template>
    <el-select
            v-model="copyValue"
            value-key="id"
            filterable
            clearable
            :disabled="disabled"
            remote
            placeholder="请选择"
            :loading-text="copyValue"
            :default-first-option="true"
            @visible-change="clearSearchkey"
            @change="updateValue"
            :remote-method="doSearchFn"
            :style="'width:100%;min-width:250px'">
        <el-option
                v-if="columns && columns.length > 0"
                style="border-bottom:1px solid #e4e7ed;color: #909399;font-weight: 600"
                :disabled="true"
                key=""
                value="">
             <span   v-for="(column,index) in columns"
                     :key="index"
                     class="columns"
                     :style="{width:column.width?column.width:((1/columns.length)*100 + '%')}">
                {{ column.title }}
            </span>
        </el-option>
        <el-option
                v-for="(item) in dataList"
                :key="item.value"
                style="border-bottom:1px solid #e4e7ed"
                :label="item[labelKey]"
                :value="item[valueKey]">
                 <span   v-if="columns && columns.length > 0"
                         class="columns"
                         v-for="(column,index) in columns"
                         :key="index"
                         :title="item[column.name]"
                         :style="{width:column.width?column.width:((1/columns.length)*100 + '%')}">
                    {{ item[column.name] }}
                </span>
        </el-option>
        <div class="paginationWrapper">
            <!-- <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="pageInfo.pageNo"
                    :page-size="pageInfo.pageSize"
                    layout="prev, pager, next,total"
                    :total="total">
            </el-pagination> -->
            <pagination
                    class="limit"
                    :page-sizes="[5, 10, 20]"
                    :total="total"
                    :page.sync="pageInfo.pageNo"
                    :limit.sync="pageInfo.pageSize"
                    @pagination="paginationChange">
                </pagination>
        </div>
    </el-select>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
    export default {
        name: "selectPage",
        components:{Pagination},
        props:{
            //绑定值
            value: String,
            // 下拉搜索列表列项条目  eg: columns:[{name:'',width:''},{name:'',width:''}]
            columns: Array,
            //下拉列表
            dataList: Array,
            //option的label在列表中对应的key
            labelKey: String,
            //option的value在列表中对应的key
            valueKey: String,
            //分页-每页大小
            pageSize: {type: Number, default: 5},
            //分页-每页大小
            disabled: {type: Boolean, default: false}
        },
        data() {
            return {
                copyValue:this.value,
                defaultValueCopy:this.defaultValue,
                total:0,
                pageInfo:{
                    pageNo:1,
                    pageSize:5,
                    wordkey:'',
                }
            };
        },
        watch:{
            value:{
                handler:function(val){
                    this.copyValue=val;
                },
                deep:true
            },
            dataList:{
                handler:function(val){
                    this.dataList=val;
                },
                deep:true
            },
        },
        mounted() {


        },
        methods:{
            //更新值
            updateValue(){

                this.$emit('update:value',this.copyValue);
                this.$emit('onSelect',this.copyValue);

            },

            doSearchFn(val){
                this.pageInfo.pageNo=1;
                this.pageInfo.wordkey=val;
                this.doSearch();
            },
            doSearch(){
                var me=this;
                this.$emit('doSearchMethod',this.pageInfo,function (total) {
                    console.log('total:',total)
                    me.total=total
                });
            },
            reSearch(){

                this.pageInfo.pageNo=1;
                this.pageInfo.wordkey='';
                var me=this;
                this.$emit('doSearchMethod',this.pageInfo,function (total) {
                    console.log('total:',total)
                    me.total=total
                });

            },
            //翻页
            handleCurrentChange(val) {
                this.pageInfo.pageNo=val;
                this.doSearch();
            },
            paginationChange(obj){
                this.pageInfo.pageNo= obj.page||1
                this.pageInfo.pageSize=obj.limit||5
                this.doSearch();
            },
            clearSearchkey(){
                this.pageInfo.pageNo=1;
                this.doSearchFn('');
            }
        },


    }
</script>

<style scoped>

    .paginationWrapper{
        margin-top:6px;
    }
    .columns{
        float: left;
        padding-left: 10px;
        min-width: 120px !important;
        border-right:1px solid #e4e7ed;

        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .columns:first-child{
        padding-left: 0px;
    }
    .columns:last-child{
        border-right: none;

    }

</style>